import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './styles/tokens.css';
import './styles/base.css';

import AppBase from './AppBase';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppBase />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
